import { FC, useEffect } from "react";
import { Stack } from "@mui/material";
import { useDidMount } from "rooks";
import { ResourceDetailsGeneralContentTags } from "./components/ResourceDetailsGeneralContentTags";
import { ResourceDetailsGeneralContentDetails } from "./components/details/ResourceDetailsGeneralContentDetails";
import { ResourceDetailsGeneralContentK8SUsage } from "./components/kubernetes/usage/ResourceDetailsGeneralContentK8SUsage";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { resourceDetailsTargetResourceSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceSelector";
import { ResourceDetailsGeneralContentK8SCosts } from "@/components/pages/common/resource-details/components/content/general-content/components/kubernetes/ResourceDetailsGeneralContentK8SCosts";
import { setResourceDetailsBillingDataProcesses } from "@/store/resource-details/resourceDetailsSlice";
import { resourceDetailsGeneralTabProcessKey } from "@/store/resource-details/utils/constants/processesKeys";
import { getResourceDetailsResourceBillingDataThunk } from "@/store/resource-details/thunks/data/getResourceDetailsResourceBillingDataThunk";

export const ResourceDetailsK8SGeneralContent: FC = () => {
  const dispatch = useAppDispatch();
  const resource = useAppSelector(resourceDetailsTargetResourceSelector);
  const k8sMetadata = resource?.providerMetadata?.k8s;
  const resourceId = k8sMetadata ? resource?.provider_unique_identifier : "";
  const isK8sPod = resource?.resourceType === "kubernetes_pod";

  useDidMount(() => {
    if (!isK8sPod) {
      dispatch(
        setResourceDetailsBillingDataProcesses({
          [resourceDetailsGeneralTabProcessKey]: {
            groupBy: "workload_name",
            chartType: "column",
          },
        }),
      );
    }
  });

  useEffect(() => {
    if (resourceId && !isK8sPod) {
      dispatch(getResourceDetailsResourceBillingDataThunk());
    }
  }, [dispatch, isK8sPod, resourceId]);

  if (!k8sMetadata) {
    return null;
  }

  return (
    <Stack spacing={1.5} p={1.5}>
      {!isK8sPod && <ResourceDetailsGeneralContentK8SCosts />}

      {isK8sPod && <ResourceDetailsGeneralContentK8SUsage />}

      <ResourceDetailsGeneralContentDetails />

      {k8sMetadata.labels && (
        <ResourceDetailsGeneralContentTags
          loading={false}
          label="Kubernetes Labels"
          tags={k8sMetadata.labels}
        />
      )}
    </Stack>
  );
};
